'use client';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import plTranslations from '@/locales/pl.json';
import enTranslations from '@/locales/en.json';
import { defaultLocale, locales } from './i18n-config';

if (!i18n.isInitialized) {
  // Synchroniczne wczytanie initialLng z <html lang> (set przez server)
  const initialLng =
    typeof document !== 'undefined' ? document.documentElement.lang : defaultLocale;
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        pl: { translation: plTranslations },
        en: { translation: enTranslations },
      },
      lng: initialLng,
      fallbackLng: defaultLocale,
      supportedLngs: [...locales],
      interpolation: { escapeValue: false },
      detection: {
        order: ['htmlTag', 'cookie', 'navigator'],
        caches: ['cookie'],
        lookupCookie: 'NEXT_LOCALE',
      },
    });
}

export default i18n;
